
export const BACKEND_IP = process.env.REACT_APP_BACKEND_IP;
